import Axios from 'axios'
import requestPrefix from '../requestPrefix'

export default {
  // 课程分类统计
  mobileclassclassify(args) {
    return Axios({
      url: requestPrefix.trainUrl + '/mobile/class/manage/classify',
      method: 'get',
      params: args
    })
  },
  // 课程列表（分页)
  mobileclasspage(args) {
    return Axios({
      url: requestPrefix.trainUrl + '/mobile/class/manage/page',
      method: 'get',
      params: args
    })
  },
  // 课程详情
  mobileclassdetail(args) {
    return Axios({
      url: requestPrefix.trainUrl + '/mobile/class/manage/detail',
      method: 'get',
      params: args
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/coursemanage/index.js